/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

import {useRef, useState} from "react";
import {useOutsideClick} from "../../hooks/useOutsideClick";
import {AntiSignatureForm} from "./AntiSignatureForm";
import {RequestType} from "../../model/RequestType";
import {AntiSignatureEntry, AntiSignatureType} from "../../model/AntiSignatureEntry";
/**
 * @author pdoriand Sep 04, 2024
 */
interface AntiSignatureButtonsProps {
    antisignature: AntiSignatureEntry,
    refreshAntiSignatures: () => void;
}

export function AntiSignatureButtons({antisignature, refreshAntiSignatures}: AntiSignatureButtonsProps) {
    const [showUpdate, setShowUpdate] = useState<boolean>(false);
    const [showCopy, setShowCopy] = useState<boolean>(false);
    const [showDelete, setShowDelete] = useState<boolean>(false);

    const updateButtonRef = useRef(null);
    const copyButtonRef = useRef(null);
    const deleteButtonRef = useRef(null);
    const updateModalRef = useRef(null);
    const copyModalRef = useRef(null);
    const deleteModalRef = useRef(null);

    useOutsideClick([updateButtonRef, updateModalRef], () => setShowUpdate(false));
    useOutsideClick([copyButtonRef, copyModalRef], () => setShowCopy(false));
    useOutsideClick([deleteButtonRef, deleteModalRef], () => setShowDelete(false));

    return <td>
        <button hidden={antisignature.signatureType === AntiSignatureType.BAD_FORMAT} className="update-button" onClick={() => setShowUpdate(!showUpdate)}
                ref={updateButtonRef}>Edit
        </button>
        <button hidden={antisignature.signatureType === AntiSignatureType.BAD_FORMAT} className="copy-button" onClick={() => setShowCopy(!showCopy)}
                ref={copyButtonRef}>Copy
        </button>
        <button hidden={antisignature.signatureType === AntiSignatureType.BAD_FORMAT} className="delete-button" onClick={() => setShowDelete(!showDelete)}
                ref={deleteButtonRef}>Delete
        </button>
        {showUpdate &&
            <div className="modal">
                <div className="modal-content" ref={updateModalRef}>
                    <AntiSignatureForm refreshAntiSignatures={refreshAntiSignatures} requestType={RequestType.UPDATE_ANTISIGNATURE}
                                       setShowWindowForm={setShowUpdate} antiSignature={antisignature}/>
                </div>
            </div>
        }
        {showCopy &&
            <div className="modal">
                <div className="modal-content" ref={copyModalRef}>
                    <AntiSignatureForm refreshAntiSignatures={refreshAntiSignatures} requestType={RequestType.ADD_ANTISIGNATURE}
                                       setShowWindowForm={setShowCopy} antiSignature={antisignature}/>
                </div>
            </div>
        }
        {showDelete &&
            <div className="modal">
                <div className="modal-content" ref={deleteModalRef}>
                    <AntiSignatureForm refreshAntiSignatures={refreshAntiSignatures} requestType={RequestType.REMOVE_ANTISIGNATURE}
                                       setShowWindowForm={setShowDelete} antiSignature={antisignature}/>
                </div>
            </div>
        }
    </td>
}